import FormField from "../../../shared/components/FormField";
import SocialAuthButtons from "./SocialAuthButtons";
import { useSignup, SIGNUP_STEP } from "../hooks/useSignup";

export default function SignupForm({ onSuccess }) {
    const {
        fields, set, fieldErrors,
        step, otp, setOtp, otpError,
        loading, error,
        handleDetailsSubmit, handleOtpSubmit, resendOtp, backToDetails,
    } = useSignup({ onSuccess });

    if (step === SIGNUP_STEP.OTP) {
        return (
            <form className="ogm-auth-form" onSubmit={handleOtpSubmit} noValidate>
                <p className="ogm-otp-sent-to">
                    We sent a 6-digit code to <strong>{fields.email}</strong> to confirm
                    it's really you before creating your account.
                </p>

                <FormField
                    type="text"
                    inputMode="numeric"
                    placeholder="Enter 6-digit code"
                    maxLength={6}
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                    error={otpError}
                    autoFocus
                    required
                />

                {error && (
                    <p className="ogm-auth-error" role="alert">
                        {error}
                    </p>
                )}

                <button className="ogm-primary-btn" disabled={loading} type="submit">
                    {loading ? "Verifying…" : "Verify & Create Account"}
                </button>

                <span className="ogm-resend-otp" onClick={resendOtp} role="button" tabIndex={0}>
                    Resend code
                </span>

                <span className="ogm-back-link" onClick={backToDetails} role="button" tabIndex={0}>
                    ← Back
                </span>
            </form>
        );
    }

    return (
        <form className="ogm-auth-form" onSubmit={handleDetailsSubmit} noValidate>
            <FormField
                type="text"
                placeholder="Full Name"
                value={fields.name}
                onChange={set("name")}
                error={fieldErrors.name}
                required
            />

            <FormField
                type="email"
                placeholder="Email address"
                value={fields.email}
                onChange={set("email")}
                error={fieldErrors.email}
                required
            />

            <FormField
                type="password"
                placeholder="Create password"
                value={fields.password}
                onChange={set("password")}
                error={fieldErrors.password}
                required
            />

            {error && (
                <p className="ogm-auth-error" role="alert">
                    {error}
                </p>
            )}

            <button className="ogm-primary-btn" disabled={loading} type="submit">
                {loading ? "Sending code…" : "Create Account"}
            </button>

            <SocialAuthButtons />
        </form>
    );
}
